
<script>
import favoriteIcon from '@/assets/images/icons/favorite.svg?inline'
import favoriteFilledIcon from '@/assets/images/icons/favorite-filled.svg?inline'

export default {
  name: 'favorite-toggler',
  components: {
    favoriteIcon,
    favoriteFilledIcon
  },
  props: {
    storeModule: {
      type: String,
      default: () => '',
      required: true
    },
    hotelId: {
      type: Number,
      default: () => null,
    },
    searchId: {
      type: String,
      default: () => ''
    },
    accommodationId: {
      type: String,
      default: () => ''
    },
    favoriteId: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    isFavoriteLoading() {
      return this.$store.getters[`${this.storeModule}/isFavoriteLoading`]
    }
  },
  methods: {
    addToFavorite() {
      this.$store.dispatch(`${this.storeModule}/addFavorite`, {
        searchId: this.searchId,
        hotelId: this.hotelId,
        accommodationId: this.accommodationId
      })
    },
    removeFavorite() {
      this.$store.dispatch(`${this.storeModule}/removeFavorite`, {
        ids: [this.favoriteId]
      })
    }
  }
}
</script>
<template>
  <div class="favorite-toggler">
    <favorite-icon
      v-if="favoriteId === null"
      class="favorite-toggler__icon"
      :class="{
        'favorite-toggler__icon--disabled': isFavoriteLoading
      }"
      @click="isFavoriteLoading ? null : addToFavorite()"
    />
    <favorite-filled-icon
      v-else
      class="favorite-toggler__icon"
      :class="{
        'favorite-toggler__icon--disabled': isFavoriteLoading
      }"
      @click="isFavoriteLoading ? null : removeFavorite()"
    />
    <div class="favorite-toggler__helper">
      <b-loading
        :is-full-page="false"
        :active="isFavoriteLoading"
        :can-cancel="true"
      />
      {{
        favoriteId === null
          ? 'Добавить в избранное'
          : 'Убрать из избранного'
      }}
    </div>
  </div>
</template>
